import { Mention } from '@syncfusion/ej2-dropdowns';
import { DropDownList } from '@syncfusion/ej2-dropdowns';
import { RichTextEditor } from '@syncfusion/ej2-richtexteditor';

import { PlaceholderPopupProps } from '@/shared/types/components';
import {
  CustomFieldIndex,
  CustomFieldModelName,
  CustomFieldRegex,
  CustomFieldSettings,
} from '@/shared/types/customFields';
import { ClientType } from '@/shared/types/enum';
import { PLACEHOLDER_DELIMITERS, PlaceholderPrefix, placeholdersForPrefixes } from '@/shared/utils/template';

import { getCustomFieldSettings } from '@/front/customFields';
import { getControl } from '@/front/editable/state';
import { listen } from '@/front/event';

let customFieldSettings: CustomFieldSettings;

listen('editablesReady', async () => {
  [...document.querySelectorAll('.placeholder-popup')]
    .map((element) => element as HTMLElement)
    .forEach(async function (element) {
      const { editableId, prefixes } = JSON.parse(element.dataset.props!) as PlaceholderPopupProps;

      const form = element.closest('form') as HTMLFormElement;

      const clientTypeEditable = form.querySelector('.editable[data-field="clientType"]') as HTMLDivElement | null;

      const clientTypeDropDownList = clientTypeEditable
        ? (getControl(clientTypeEditable.id) as DropDownList)
        : undefined;

      const editor = getControl(editableId!) as RichTextEditor;

      const target = editor.element.getElementsByClassName('e-content')[0] as HTMLElement;

      const mention = new Mention({
        dataSource: await getPlaceholders(prefixes),
        fields: { text: 'displayName', value: 'name' },
        target,
        mentionChar: PLACEHOLDER_DELIMITERS[0][0],
        suggestionCount: 1000,
        popupWidth: '400px',
        popupHeight: '300px',
        highlight: true,
        noRecordsTemplate: 'No matching placeholders',
        displayTemplate: `${PLACEHOLDER_DELIMITERS[0]}\${name}${PLACEHOLDER_DELIMITERS[1]}`,
      });

      const refresh = async () => {
        const clientType = (clientTypeDropDownList?.value ?? undefined) as ClientType | undefined;
        mention.dataSource = await getPlaceholders(prefixes, clientType);
      };

      mention.appendTo(element);

      refresh();

      if (clientTypeEditable) {
        const clientTypeDropDownList = getControl(clientTypeEditable.id) as DropDownList;
        clientTypeDropDownList.addEventListener('change', refresh);
      }

      // Don't add line break when selecting placeholder by pressing enter
      editor.actionBegin = (args) => {
        if (args.requestType === 'EnterAction' && mention.element.classList.contains('e-popup-open')) {
          args.cancel = true;
        }
      };
    });
});

const getPlaceholders = async (prefixes: PlaceholderPrefix[], clientType?: ClientType) => {
  if (!customFieldSettings) {
    customFieldSettings = await getCustomFieldSettings();
  }

  const placeholders = placeholdersForPrefixes(prefixes, clientType);

  return placeholders.map((placeholder) => {
    let customName = '';

    const prefix = placeholder.name.substring(0, placeholder.name.indexOf('.')); // TODO make prefix property of placeholder

    if (prefix in customFieldSettings) {
      const customFieldMatch = placeholder.column.match(CustomFieldRegex);

      if (customFieldMatch) {
        customName =
          customFieldSettings[prefix as CustomFieldModelName]![customFieldMatch![1] as CustomFieldIndex]?.name ?? '';
      }
    }

    return {
      ...placeholder,
      displayName: `${placeholder.name}${customName ? ` (${customName})` : ''}`,
    };
  });
};
